export default "/_next/static/images/c0935408ff063d8a8fc9ce3d5961ba3c.png";